import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListChecks = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.178 6.735a1 1 0 0 0-1.356-1.47L7.163 8.639 5.68 7.266a1 1 0 0 0-1.358 1.468l2.163 2a1 1 0 0 0 1.356.001l4.338-4ZM16 7a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H16ZM16 15a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H16ZM15 24a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1ZM12.235 13.322a1 1 0 0 1-.057 1.413l-4.338 4a1 1 0 0 1-1.356 0l-2.163-2a1 1 0 0 1 1.358-1.47l1.484 1.374 3.66-3.374a1 1 0 0 1 1.412.057ZM12.178 22.735a1 1 0 1 0-1.356-1.47l-3.659 3.374-1.484-1.373a1 1 0 0 0-1.358 1.468l2.163 2a1 1 0 0 0 1.356.001l4.338-4Z",
		fill: "currentColor"
	})
});
export default SvgListChecks;
